import React from 'react';
import {da} from 'date-fns/locale';
import classNames from 'classnames';
import * as S from './SupplierProgressList.styles';
import {ISupplierRequiredDetailsList} from '../../../../../shared/types/aisProfile';
const SuppliersProgressList: React.FC<ISupplierRequiredDetailsList> = (
  data,
): React.ReactElement => {
  const {items, styles} = data;

  return (
    <S.SupplierProgressListMainWrap className={`${classNames(styles?.customClasses)}`}>
      <ul className={`suppliersListWrpr }`}>
        {items?.length > 0 &&
          items.map(({isCompleted, itemImage, itemText}) => {
            return (
              <>
                {isCompleted ? (
                  <li className="suppliersListItem">
                    <span className={`${classNames(itemImage?.data?.styles?.iconClasses)}`}></span>
                    <span className="font16 lineHeight24 latoBlack appendLeft8">
                      {itemText?.data?.primaryText}
                    </span>
                  </li>
                ) : (
                  <li className="suppliersListItem">
                    <span className={`${classNames(itemImage?.data?.styles?.iconClasses)}`}></span>
                    <span className="font16 lineHeight24 secondaryTxt appendLeft8">
                      {itemText?.data?.primaryText}
                    </span>
                  </li>
                )}
              </>
            );
          })}
      </ul>
    </S.SupplierProgressListMainWrap>
  );
};

export default SuppliersProgressList;
